const data_dictionary_map = {
  // page: "a0",
  menu: "a1",
  id: "a2",
  // appIdList: "a3", // 该属性不加密，方便后台获取处理
  name: "a4",
  // type: "a5",
  children: "a6",
  isActive: "a7",
  thumbnail: "a8",
  attribute: "a9",
  color: "b0",
  style: "b1",
  width: "b2",
  height: "b3",
  top: "b4",
  left: "b5",
  draggable: "b6",
  resizable: "b7",
  parentLim: "b8",
  zIndex: "b9",
  active: "c0",
  shape: "c",
  html: "c2",
  options: "c3",
  innerElement: "c4",
  showButtonNext: "c5",
  showButtonPrev: "c6",
  showPagination: "c7",
  direction: "c8",
  speed: "c9",
  autoplay: "d0",
  slidesPerView: "d1",
  centeredSlides: "d2",
  pagination: "d3",
  clickable: "d4",
  navigation: "d5",
  nextEl: "d6",
  prevEl: "d7",
  effect: "d8",
  content: "d9",
  tabs: "e1",
  rows: "e2",
  cols: "e3",
  uid: "e4",
  alignSelf: "e5",
  alginH: "e6",
  md: "e7",
  appMd: "e8",
  offsetMd: "e9",
  margin: "f0",
  Top: "f1",
  component: "f2",
  elementOptions: "f3",
  clipSize: "f4",
  repeatType: "f5",
  horAlignType: "f6",
  verAlignType: "f7",
  imgSrc: "f8",
  opacity: "f9",
  borderRadius: "g0",
  hoverZoomLevel: "g1",
  linkUrl: "g2",
  fontSize: "g3",
  fontWeight: "g4",
  fontFamily: "g5",
  background: "g6",
  lineHeight: "g7",
  fontStyle: "g8",
  borderTopWidth: "g9",
  borderRightWidth: "h0",
  borderBottomWidth: "h1",
  borderLeftWidth: "h2",
  borderStyle: "h3",
  borderColor: "h4",
  textIndent: "h5",
  isShowTabs: "h6",
  isShowTitle: "h7",
  isShowMoreBtn: "h8",
  moduleId: "h9",
  appId: "i0",
  isCache: "i1",
  animateSets: "i2",
  animateType: "i3",
  animateDirection: "i4",
  animateDuration: "i5",
  animateDelay: "i6",
  hasDirection: "i7",
  animateTriggerNumType: "i8",
  animateClass: "i9",
  executionAnimateClass: "j0",
  shapeType: "j1",
  borderTopLeftRadius: "j2",
  borderTopRightRadius: "j3",
  borderBottomLeftRadius: "j4",
  borderBottomRightRadius: "j5",
  borderWidth: "j6",
  boxShadow: "j7",
  rotate: "j8",
  alignType: "j9",
  openBlankPage: "k0",
  accessRulers: "k1",
  textDecoration: "k2",
  writingMode: "k3",
  textAlign: "k4",
  textLimitLines: "k5",
  cacheAppIds: "k6",
  nocacheAppIds: "k7",
  hasFixedHeader: "k8",
  headerIsFixed: "k9",
  backgroundImage: "l1",
  openBgSet: "l2",
  bgType: "l3",
  bgColor: "l4",
  hoverFontFamily: "l5",
  hoverFontSize: "l6",
  hoverFontWeight: "l7",
  hoverColor: "l8",
  hoverBackground: "l9",
  hoverFontStyle: "m0",
  hoverTextDecoration: "m1",
  hoverBorderTopLeftRadius: "m2",
  hoverBorderTopRightRadius: "m3",
  hoverBorderBottomLeftRadius: "m4",
  hoverBorderBottomRightRadius: "m5",
  hoverBorderStyle: "m6",
  hoverBorderColor: "m7",
  hoverBorderWidth: "m8",
  hoverBoxShadowColor: "m9",
  hoverBoxShadowH: "n0",
  hoverBoxShadowV: "n1",
  hoverBoxShadowBlur: "n2",
  hoverBoxShadowSpread: "n3",
  hoverBgType: "n4",
  hoverBgColor: "n5",
  hoverClipSize: "n6",
  hoverRepeatType: "n7",
  hoverAlignType: "n8",
  hoverImgSrc: "n9",
  pageWidth: "o0",
  openComplexFont: "o1",
  themeColor: "o2",
  hoverLineHeight: "o3",
  hoverLetterSpacing: "o4",
  hoverTextAlign: "o5",
  hoverWritingMode: "o6",
  hoverRotate: "o7",
  hoverTop: "o8",
  hoverLeft: "o9",
  hoverType: "q0",
  textType: "q1",
  borderColorType: "q2",
  borderColorModel: "q3",
  hoverBorderColorModel: "q4",
  backgroundColorModel: "q5",
  hoverBackgroundColorModel: "q6",
  isShowBackgroundModel: "q7",
  tabMarginRight: "q8",
  tabWidth: "q9",
  tabHeight: "r0",
  maxLength: "r1",
  hoverMaxLength: "r2",
  hoverTextIndent: "r3",
  isFixed: "r4",
  fixedPos: "r5",
  inDocument: "r6",
  marginTop: "r7",
  // =======
  hasHeader: "r8",
  container_id: "r9",
  rect_id: "s0",
  swiperContent_id: "s1",
  elementInSwiperId: "s2",
  // linkHeader: "s3",
  letterSpacing: "s4",
  createBlockTimes: "s5",
  activeIndex: "s6",
  boxShadowColor: "s7",
  boxShadowH: "s8",
  boxShadowV: "s9",
  boxShadowBlur: "t0",
  boxShadowSpread: "t1",
  titleOptions: "t2",
  isShow: "t3",
  iconSrc: "t4",
  iconWidth: "t5",
  iconHeight: "t6",
  iconAlign: "t7",
  hoverIconSrc: "t8",
  tabBackgroundColor: "t9",
  tabsList: "u0",
  componentBoxOptions: "u1",
  paddingTop: "u2",
  paddingBottom: "u3",
  paddingLeft: "u4",
  paddingRight: "u5",
  padding: "u10",
  // ====== 图表
  typeName: "u6",
  refreshTime: "u7",
  initOptions: "u8",
  renderer: "u9",
  chartOption: "x0",
  tooltip: "x1",
  // show: "x2",//图表中渐变色会使用x2
  trigger: "x3",
  axisPointer: "x4",
  textStyle: "x5",
  backgroundColor: "x6",
  showContent: "x7",
  extraCssText: "x8",
  grid: "x9",
  right: "y0",
  bottom: "y1",
  // containLabel: "y2",//图表中渐变色会使用y2
  legend: "y3",
  animationDuration: "y4",
  xAxis: "y5",
  data: "y6",
  axisTick: "y7",
  alignWithLabel: "y8",
  axisLine: "y9",
  lineStyle: "z0",
  splitLine: "z1",
  axisLabel: "z2",
  yAxis: "z3",
  series: "z4",
  barWidth: "z5",
  colorBy: "z6",
  itemStyle: "z7",
  radius: "z8",
  center: "z9",
  label: "a00",
  position: "a01",
  formatter: "a02",
  labelLine: "a03",
  value: "a04",
  emphasis: "a05",
  shadowBlur: "a06",
  shadowOffsetX: "a07",
  shadowColor: "a08",
  shapeChecked: "a09",
  borderChecked: "a10",
  borderShadowChecked: "a11",
  rotateChecked: "a12",
  clipPath: "a13",
  skew: "a14",
  startColor: "a15",
  endColor: "a16",
  colorType: "a17",
  singleColor: "a18",
  showBackground: "a19",
  zlevel: "a20",
  period: "a21",
  trailLength: "a22",
  symbol: "a23",
  symbolSize: "a24",
  dashOffset: "a25",
  curveness: "a26",
  coordinateSystem: "a27",
  rippleEffect: "a28",
  number: "a29",
  brushType: "a30",
  scale: "a31",
  selectedMode: "a32",
  geo: "a33",
  areaColor: "a34",
  colorStops: "a35",
  global: "a36",
  shadowOffsetY: "a37",
  select: "a38",
  offset: "a39",
  map: "a40",
  normal: "a42",
  setting: "a43",
  coord: "a44",
  textIsThemeColor: "a45",
  hoverTextIsThemeColor: "a46",
  colorlinearGradientAngle: "a47",
  bgColorIsThemeColor: "a48",
  iconPosition: "a49",
  iconType: "a50",
  iconMargin: "a51",
  iconColorIsThemeColor: "a52",
  iconColor: "a53",
  borderIsThemeColor: "a54",
  titleOptionsWidth: "a55",
  titleOptionsHeight: "a56",
  hoverBgColorIsThemeColor: "a57",
  mode: "a58",
  collapse: "a59",
  widthAuto: "a60",
  activeBgColor: "a61",
  activeBgIsThemeColor: "a62",
  activeBorderWidth: "a63",
  activeBorderColor: "a64",
  activeBorderStyle: "a65",
  activeBorderIsThemeColor: "a66",
  hoverBgIsThemeColor: "a67",
  hoverBorderIsThemeColor: "a68",
  topNavTextLimit: "a69",
  topNavTextLimitCount: "a70",
  topNavBorderWidth: "a71",
  topNavBorderColor: "a72",
  topNavBorderStyle: "a73", // solid, dashed, dotted
  topNavBorderIsThemeColor: "a74",
  topNavBoxShadowColor: "a75",
  topNavBoxShadowH: "a76",
  topNavBoxShadowV: "a77",
  topNavBoxShadowBlur: "a78",
  topNavBoxShadowSpread: "a79",
  topNavBorderTypeFlag: "a80",
  topNavBorderRadius: "a81",
  topNavBorderBottomLeftRadius: "a82",
  topNavBorderBottomRightRadius: "a83",
  topNavBorderTopRightRadius: "a84",
  topNavBorderTopLeftRadius: "a85",
  topNavPadding: "a86",
  topNavPaddingTop: "a87",
  topNavPaddingRight: "a88",
  topNavPaddingLeft: "a89",
  topNavPaddingBottom: "a90",
  topNavPaddingTypeFlag: "a91",
  liHoverFontFamily: "a92",
  liHoverFontSize: "a93",
  liHoverFontWeight: "a94",
  liHoverFontColor: "a95",
  liHoverBgColor: "a96",
  liHoverBgIsThemeColor: "a97",
  liHoverBorderWidth: "a98",
  liHoverBorderColor: "a99",
  liHoverBorderStyle: "a100", // solid, dashed, dotted
  liHoverBorderIsThemeColor: "b00",
  selectBoxShadowColor: "b01", // 下拉列表的阴影
  selectBoxShadowH: "b02",
  selectBoxShadowV: "b03",
  selectBoxShadowBlur: "b04",
  selectBoxShadowSpread: "b05",
  hideOnSinglePage: "b06",
  showJumper: "b07",
  showTotal: "b08",
  maxPageBtnNum: "b09",
  pageTurnType: "b10",
  pageTurnIcon: "b12",
  pageTurnIconColor: "b13",
  pageTurnIconIsThemeColor: "b14",
  pageTurnFontSize: "b15",
  pageTurnFontColor: "b16",
  pageTurnFontFamily: "b17",
  pageTurnFontWeight: "b18",
  pageTurnHeight: "b19",
  pageTurnMinWidth: "b20",
  pageTurnBgColor: "b21",
  pageTurnBgIsThemeColor: "b22",
  pageTurnBorderColor: "b23",
  pageTurnBorderStyle: "b24",
  pageTurnBorderWidth: "b25",
  pageTurnBorderIsThemeColor: "b26",
  pageTurnPadding: "b27",
  pageTurnPaddingTop: "b28",
  pageTurnPaddingRight: "b29",
  pageTurnPaddingLeft: "b30",
  pageTurnPaddingBottom: "b31",
  pageTurnPaddingTypeFlag: "b32",
  pageTurnBorderTypeFlag: "b33",
  pageTurnBorderRadius: "b34",
  pageTurnBorderTopLeftRadius: "b35",
  pageTurnBorderTopRightRadius: "b36",
  pageTurnBorderBottomLeftRadius: "b37",
  pageTurnBorderBottomRightRadius: "b38",
  hoverPageTurnIconColor: "b39",
  hoverPageTurnFontColor: "b40",
  hoverPageTurnBgColor: "b41",
  hoverPageTurnBgIsThemeColor: "b42",
  hoverPageTurnBorderColor: "b43",
  hoverPageTurnBorderStyle: "b44",
  hoverPageTurnBorderWidth: "b45",
  hoverPageTurnBorderIsThemeColor: "b46",
  hoverPageTurnPadding: "b47",
  hoverPageTurnPaddingTop: "b48",
  hoverPageTurnPaddingRight: "b49",
  hoverPageTurnPaddingLeft: "b50",
  hoverPageTurnPaddingBottom: "b51",
  hoverPageTurnPaddingTypeFlag: "b52",
  hoverPageTurnBorderTypeFlag: "b53",
  hoverPageTurnBorderRadius: "b54",
  hoverPageTurnBorderTopLeftRadius: "b55",
  hoverPageTurnBorderTopRightRadius: "b56",
  hoverPageTurnBorderBottomLeftRadius: "b57",
  hoverPageTurnBorderBottomRightRadius: "b58",
  otherFontColor: "b59",
  otherFontSize: "b60",
  otherFontFamily: "b61",
  otherFontWeight: "b62",
  positionType: "b63",
  imgUrl: "b64",
  isThemeColor: "b65",
  buttonIconBackGroundBorderRadius: "b66",
  buttonLeft: "b67",
  bulletsMargin: "b68",
  swiperButtonType: "b69",
  buttonIconBackgroundColor: "b70",
  bulletsPrimaryColor: "b71",
  bulletsActiveColor: "b72",
  buttonIconClassName: "b73",
  buttonIconBackgroundHeight: "b74",
  borderTypeFlag: "b75",
  updateTimer: "b76",
  imgName: "b77",
  restDataUrl: "b78",
  internalLinkName: "b79",
  componentTypeId: "b80",
  loop: "b81",
  swiperMode: "b82",
  flipEffect: "b83",
  buttonIconTop: "b84",
  freeMode: "b85",
  cubeEffect: "b86",
  shadowScale: "b87",
  shadow: "b88",
  shadowOffset: "b89",
  slideShadows: "b90",
  fadeEffect: "b91",
  crossFade: "b92",
  paginationPosition: "b93",
  buttonIconSize: "b94",
  bulletsSize: "b95",
  buttonIconColor: "b96",
  buttonIconShowBackGround: "b97",
  buttonIconPadding: "b98",
  buttonTop: "b99",
  buttonIconBackgroundWidth: "c00",
  showButton: "c01",
  buttonIconCustomTop: "c02",
  progressbarBackground: "c03",
  coverflowEffect: "c04",
  stretch: "c05",
  depth: "c06",
  modifier: "c07",
  progressbarHeight: "c08",
  hoverZIndex: "c09",
  typeId: "c10",
  noCacheComponent: "c11",
  pluginName: "c12",
  allBorderBottomLeftRadius: "c13",
  allBgColor: "c14",
  contentHasLimit: "c15",
  singleTabs: "c16",
  allBorderStyle: "c17",
  allBorderTopRightRadius: "c18",
  searchType: "c19",
  hoverMaxTabLength: "c20",
  hoverUnderlineStyle: "c21",
  allBorderWidth: "c22",
  bgStartColor: "c23",
  allBorderBottomRightRadius: "c24",
  bgEndColor: "c25",
  hoverUnderlineColor: "c26",
  hoverUnderlineWidth: "c27",
  allBorderColor: "c28",
  allBorderTopLeftRadius: "c29",
  allBorderIsThemeColor: "c30",
  elementInLayoutId: "c31",
  reverseGetColsUid: "c32",
  styleName: "c33",
  myFetchParam: "c34",
  typeVal: "c35",
  pageId: "c36",
  wfwfid: "c37",
  componentVariables: "c38",
  publishComponentIds: "c39",
  events: "c40",
  mouseEvents: "c41",
  dblclick: "c42",
  mouseover: "c43",
  mouseout: "c44",
  mouseup: "c45",
  click: "c46",
  mousedown: "c47",
  dataEvents: "c48",
  appointDataChange: "c49",
  anyDataChange: "c50",
  eventMovement: "c51",
  movementType: "c52",
  groupId: "c53",
  ids: "c54",
  update: "c55",
  transitionTime: "c56",
  useVariable: "c57",
  option: "c58",
  path: "c59",
  from: "c60",
  lifeCycle: "c61",
  beforeTrigger: "c62",
  afterTrigger: "c63",
  filedMapping: "c64",
  flag: "c65",
  checked: "c66",
  movement: "c67",
  time: "c68",
  eventVariables: "c69",
  variablePath: "c70",
  variableName: "c71",
  variableTag: "c72",
  baseComponentBoxOptions: "c73",
  paddingType: "c74",
  bgColorType: "c75",
  detailsPageTarget: "c76",
  dataUrl: "c77",
  hoverHeight: "c78",
  textOverFlowType: "c79",
  hoverWidth: "c80",
  hoverStartColor: "c81",
  hoverEndColor: "c82",
  hoverColorType: "c83",
  bgAngleValue: "c84",
  linearGradient: "c85",
  shapeUrl1: "c86",
  shapeBorderColor: "c87",
  shapeUrl2: "c88",
  linearGradient1: "c89",
  linearGradient2: "c90",
  shapeColor2: "c91",
  borderLinearGradient: "c92",
  shapeColor1: "c93",
  shapeColor: "c94",
  bgAngleValue2: "c95",
  bgAngleValue1: "c96",
  pathD: "c97",
  viewBox: "c98",
  marginRight: "c99",
  marginBottom: "d01",
  marginLeft: "d02",
  matchValue: "d03",
  stopOnLastSlide: "d04",
  disableOnInteraction: "d05",
  layoutUidMap: "d06",
  placeHolderFontSize: "d07",
  thumbsHeight: "d08",
  thumbsActiveBorderTopLeftRadius: "d09",
  thumbsActiveBorderTopRightRadius: "d10",
  thumbsActiveBorderBottomRightRadius: "d11",
  thumbsActiveBorderBottomLeftRadius: "d12",
  thumbsBorderWidth: "d13",
  thumbsActiveBorderWidth: "d14",
  thumbsBorderTopLeftRadius: "d15",
  thumbsBorderTopRightRadius: "d16",
  thumbsBorderBottomRightRadius: "d17",
  thumbsBorderBottomLeftRadius: "d18",
  thumbsBoxShadowH: "d19",
  thumbsBoxShadowV: "d20",
  thumbsBoxShadowBlur: "d21",
  thumbsBoxShadowSpread: "d22",
  thumbsActiveBoxShadowH: "d23",
  thumbsActiveBoxShadowV: "d24",
  thumbsActiveBoxShadowBlur: "d25",
  thumbsActiveBoxShadowSpread: "d26",
  thumbsPadding: "d27",
  thumbsPaddingTop: "d28",
  thumbsPaddingRight: "d29",
  thumbsPaddingBottom: "d30",
  thumbsPaddingLeft: "d31",
  rectangleWidth: "d32",
  rectangleHeight: "d33",
  rectangleActiveWidth: "d34",
  rectangleActiveHeight: "d35",
  bulletsRadius: "d36",
  paginationTop: "d37",
  paginationBottom: "d38",
  paginationLeft: "d39",
  paginationRight: "d40",
  fractionSize: "d41",
  slideWidth: "d42",
  slideHeight: "d43",
  slideBorderRadius: "d44",
  buttonBoxShadowH: "d45",
  buttonBoxShadowV: "d46",
  buttonBoxShadowBlur: "d47",
  buttonBoxShadowSpread: "d48",
  titleFontSize: "d49",
  titleLineHeight: "d50",
  titleLetterSpacing: "d51",
  titlePadding: "d52",
  titlePaddingTop: "d53",
  titlePaddingRight: "d54",
  titlePaddingBottom: "d55",
  titlePaddingLeft: "d56",
  weekFontSize: "d57",
  lunarFontSize: "d58",
  activeBorderTopLeftRadius: "d59",
  activeBorderTopRightRadius: "d60",
  activeBorderBottomRightRadius: "d61",
  activeBorderBottomLeftRadius: "d62",
  datePaddingTopVal: "d63",
  datePaddingBottomVal: "d64",
  todayStyleFontSize: "d65",
  todayStyleBorderTopLeftRadius: "d66",
  todayStyleBorderTopRightRadius: "d67",
  todayStyleBorderBottomRightRadius: "d68",
  todayStyleBorderBottomLeftRadius: "d69",
  todayStyleBorderWidth: "d70",
  activityWidth: "d71",
  leftButtonIconX: "d72",
  leftButtonIconY: "d73",
  rightButtonIconX: "d74",
  rightButtonIconY: "d75",
  todayLegendFontSize: "d76",
  todayLegendBorderWidth: "d77",
  todayLegendBorderRadius: "d78",
  todayLegendWidth: "d79",
  todayLegendHeight: "d80",
  activityLegendFontSize: "d81",
  activityLegendBorderWidth: "d82",
  activityLegendBorderRadius: "d83",
  activityLegendWidth: "d84",
  activityLegendHeight: "d85",
  legendSpace: "d86",
  legendPadding: "d87",
  legendPaddingTop: "d88",
  legendPaddingRight: "d89",
  legendPaddingBottom: "d90",
  legendPaddingLeft: "d91",
  activeBorderRadius: "d92",
  todayStyleBorderRadius: "d93",
  lineMargin: "d94",
  columnMargin: "d95",
  groupMargin: "d96",
  defaultBorderRadius: "d97",
  defaultBorderTopLeftRadius: "d98",
  defaultBorderTopRightRadius: "d99",
  defaultBorderBottomLeftRadius: "e10",
  defaultBorderBottomRightRadius: "e11",
  defaultBorderWidth: "e12",
  defaultPadding: "e13",
  defaultPaddingTop: "e14",
  defaultPaddingRight: "e15",
  defaultPaddingBottom: "e16",
  defaultPaddingLeft: "e17",
  titleBorderRadius: "e18",
  titleBorderTopLeftRadius: "e19",
  titleBorderTopRightRadius: "e20",
  titleBorderBottomLeftRadius: "e21",
  titleBorderBottomRightRadius: "e22",
  titleBorderWidth: "e23",
  titleWidth: "e24",
  activeLetterSpacing: "e25",
  defaultBoxShadowH: "e26",
  defaultBoxShadowV: "e27",
  defaultBoxShadowBlur: "e28",
  defaultBoxShadowSpread: "e29",
  titleBoxShadowH: "e30",
  titleBoxShadowV: "e31",
  titleBoxShadowBlur: "e32",
  titleBoxShadowSpread: "e33",
  barBorderTopLeftRadius: "e34",
  barBorderTopRightRadius: "e35",
  barBorderBottomRightRadius: "e36",
  barBorderBottomLeftRadius: "e37",
  barBorderWidth: "e38",
  iconBorderWidth: "e39",
  topNavMarginBottom: "e40",
  liMarginBottom: "e41",
  liBgIsThemeColor: "e42",
  liBgColor: "e43",
  liIsSameSize: "e44",
  liWidth: "e45",
  liHeight: "e46",
  topNavBorderTypeFlag1: "e47",
  topNavBorderRadius1: "e48",
  topNavBorderTopLeftRadius1: "e49",
  topNavBorderTopRightRadius1: "e50",
  topNavBorderBottomRightRadius1: "e51",
  topNavBorderBottomLeftRadius1: "e52",
  liBorderWidth: "e53",
  liBorderStyle: "e54",
  liBorderColor: "e55",
  liBorderIsThemeColor: "e56",
  clearLiLastBorder: "e57",
  liFontFamily: "e58",
  liFontSize: "e59",
  liFontWeight: "e60",
  liFontStyle: "e61",
  liTextDecoration: "e62",
  liLineHeight: "e63",
  liLetterSpacing: "e64",
  liWritingMode: "e65",
  liTextAlign: "e66",
  liIsThemeColor: "e67",
  liFontColor: "e68",
  topNavTextLimit1: "e69",
  topNavTextLimitCount1: "e70",
  topNavBackground1: "e71",
  ulBgIsThemeColor: "e72",
  ulBgColor: "e73",
  liActiveFontFamily: "e74",
  liActiveFontSize: "e75",
  liActiveFontWeight: "e76",
  liActiveFontStyle: "e77",
  liActiveTextDecoration: "e78",
  liActiveLineHeight: "e79",
  liActiveLetterSpacing: "e80",
  liActiveWritingMode: "e81",
  liActiveTextAlign: "e82",
  liActiveTextIsThemeColor: "e83",
  liActiveFontColor: "e84",
  liActiveBorderWidth: "e85",
  liActiveBorderStyle: "e86",
  liActiveBorderColor: "e87",
  liActiveBorderIsThemeColor: "e88",
  liActiveBgIsThemeColor: "e89",
  liActiveBgColor: "e90",
  liHoverLineHeight: "e91",
  activityFontSize: "e92",
  activityBorderTopLeftRadius: "e93",
  activityBorderTopRightRadius: "e94",
  activityBorderBottomRightRadius: "e95",
  activityBorderBottomLeftRadius: "e96",
  activityBorderWidth: "e97",
  colMarginTypeFlag: "e98",
  colMargin: "e99",
  colMarginTop: "f10",
  colMarginRight: "f11",
  colMarginBottom: "f12",
  colMarginLeft: "f13",
  liBorderTopLeftRadius: "f14",
  liBorderTopRightRadius: "f15",
  liBorderBottomRightRadius: "f16",
  liBorderBottomLeftRadius: "f17",
  liHoverIsSameActive: "f18",
  textOverflowEllipsis:"f19",
  liPadding: "f20",
  liPaddingTop: "f21",
  liPaddingRight: "f22",
  liPaddingBottom: "f23",
  liPaddingLeft: "f24",
  liActivePadding: "f25",
  liActivePaddingTop: "f26",
  liActivePaddingRight: "f27",
  liActivePaddingBottom: "f28",
  liActivePaddingLeft: "f29",
  liActiveneHeight: "f30",
  activeTopNavPadding: "f31",
  activeTopNavPaddingTop: "f32",
  activeTopNavPaddingRight: "f33",
  activeTopNavPaddingLeft: "f34",
  activeTopNavPaddingBottom: "f35",
  activeLineHeight: "f36",
  moreLineHeight: "f37",
  moreFontSize: "f38",
  moreLetterSpacing: "f39",
  moreBorderWidth: "f40",
  moreBorderTopLeftRadius: "f41",
  moreBorderTopRightRadius: "f42",
  moreBorderBottomRightRadius: "f43",
  moreBorderBottomLeftRadius: "f44",
  morePaddingTop: "f45",
  morePaddingRight: "f46",
  morePaddingBottom: "f47",
  morePaddingLeft: "f48",
  moreActiveLineHeight: "f49",
  moreActiveFontSize: "f50",
  moreActiveLetterSpacing: "f51",
  moreActiveBorderWidth: "f52",
  moreActiveBorderTopLeftRadius: "f53",
  moreActiveBorderTopRightRadius: "f54",
  moreActiveBorderBottomRightRadius: "f55",
  moreActiveBorderBottomLeftRadius: "f56",
  moreActivePaddingTop: "f57",
  moreActivePaddingRight: "f58",
  moreActivePaddingBottom: "f59",
  moreActivePaddingLeft: "f60",
  morePadding: "f61",
  moreActivePadding: "f62",
  moreIconWidth: "f63",
  moreIconMargin: "f64",
  selectOptionsHeight: "f65",
  titleBorderTypeFlag: "f66",
  titleBorderIsThemeColor: "f67",
  titlePaddingTypeFlag2: "f68",
  titlePadding2: "f69",
  titlePaddingTop2: "f70",
  titlePaddingRight2: "f71",
  titlePaddingBottom2: "f72",
  titlePaddingLeft2: "f73",
  titleSelectBgIsThemeColor: "f74",
  titleSelectBgColor: "f75",
  titleBorderShadowChecked: "f76",
  titleSelectColor: "f77",
  titleSelectFontFamily: "f78",
  titleSelectFontSize: "f79",
  titleSelectFontWeight: "f80",
  titleSelectOptionsBgIsThemeColor: "f81",
  titleSelectActiveColor: "f82",
  titleSelectActiveFontFamily: "f83",
  titleSelectActiveFontSize: "f84",
  titleSelectActiveFontWeight: "f85",
  titleSelectActiveBgIsThemeColor: "f86",
  titleSelectActiveBgColor: "f87",
  activityBorderRadius: "f88",
  activityLocation: "f89",
  activityFontColor: "f90",
  activityFontFamily: "f91",
  activityFontWeight: "f92",
  activityTooltip: "f93",
  activityTooltipWidth: "f94",
  activityTooltipHeight: "f95",
  activityLineHeight: "f96",
  tooltipTitleColor: "f97",
  tooltipTitleFontFamily: "f98",
  tooltipTitleFontSize: "f99",
  tooltipTitleFontWeight: "h10",
  tooltipTimeColor: "h11",
  tooltipTimeFontFamily: "h12",
  tooltipTimeFontSize: "h13",
  tooltipTimeFontWeight: "h14",
  activityTooltipSpace: "h15",
  activityTooltipBgIsThemeColor: "h16",
  activityTooltipBgColor: "h17",
  tooltipBorderTypeFlag: "h18",
  tooltipBorderRadius: "h19",
  tooltipBorderTopLeftRadius: "h20",
  tooltipBorderTopRightRadius: "h21",
  tooltipBorderBottomRightRadius: "h22",
  tooltipBorderBottomLeftRadius: "h23",
  tooltipBorderWidth: "h24",
  tooltipBorderStyle: "h25",
  tooltipBorderColor: "h26",
  tooltipBorderIsThemeColor: "h27",
  tooltipPaddingTypeFlag: "h28",
  tooltipPadding: "h29",
  tooltipPaddingTop: "h30",
  tooltipPaddingRight: "h31",
  tooltipPaddingBottom: "h32",
  tooltipPaddingLeft: "h33",
  tooltipBoxShadowH: "h34",
  tooltipBoxShadowV: "h35",
  tooltipBoxShadowBlur: "h36",
  tooltipBoxShadowSpread: "h37",
  tooltipBoxShadowColor: "h38",
  fractionFontSize: "h39",
  fractionLineHeight: "h40",
  fractionLetterSpacing: "h41",
  selectWidth: "h42",
  rowColMargin: "h43",
  rowColMarginRight: "h44",
  maxWidth: "h45",
  maxHeight: "h46",
  minHeight: "h47",
  showTopNavIcon: "h48",
  verticalAlign: "h49",
  showTopNavBorder: "h50",
  topNavOpacity: "h51",
  topNavRotate: "h52",
  showLiBorder: "h53",
  liVerticalAlign: "h54",
  liTextLimitCount: "h55",
  liTextLimit: "h56",
  showTopNavActiveBorder: "h57",
  activeVerticalAlign: "h58",
  topNavActiveTextLimitCount: "h59",
  topNavActiveTextLimit: "h60",
  topNavActiveBorderTypeFlag: "h61",
  topNavActiveBorderRadius: "h62",
  topNavActiveBorderTopLeftRadius: "h63",
  topNavActiveBorderTopRightRadius: "h64",
  topNavActiveBorderBottomRightRadius: "h65",
  topNavActiveBorderBottomLeftRadius: "h66",
  showTopNavHoverBorder: "h67",
  hoverVerticalAlign: "h68",
  hoverTextLimitCount: "h69",
  hoverTextLimit: "h70",
  topNavHoverBorderTypeFlag: "h71",
  topNavHoverBorderRadius: "h72",
  topNavHoverBorderTopLeftRadius: "h73",
  topNavHoverBorderTopRightRadius: "h74",
  topNavHoverBorderBottomRightRadius: "h75",
  topNavHoverBorderBottomLeftRadius: "h76",
  showLiHoverBorder: "h77",
  liHoverBorderTypeFlag: "h78",
  liHoverBorderRadius: "h79",
  liHoverBorderTopLeftRadius: "h80",
  liHoverBorderTopRightRadius: "h81",
  liHoverBorderBottomRightRadius: "h82",
  liHoverBorderBottomLeftRadius: "h83",
  liHoverVerticalAlign: "h84",
  liHoverTextLimitCount: "h85",
  liHoverTextLimit: "h86",
  liIconPosition: "h87",
  showLiIcon: "h88",
  liIconSrc: "h89",
  liIconType: "h90",
  liIconWidth: "h91",
  liIconMargin: "h92",
  liIconColorIsThemeColor: "h93",
  liIconColor: "h94",
  liResInfo: "h95",
  liBorderTypeFlag: "h96",
  liBorderRadius: "h97",
  liPaddingTypeFlag: "h98",
  liOpacity: "h99",
  liRotate: "i10",
  liMargin: "i11",
  ulBackground: "i12",
  showUlBorder: "i13",
  ulBorderWidth: "i14",
  ulBorderColor: "i15",
  ulBorderStyle: "i16",
  ulBorderIsThemeColor: "i17",
  ulBorderTypeFlag: "i18",
  ulBorderRadius: "i19",
  ulBorderTopLeftRadius: "i20",
  ulBorderTopRightRadius: "i21",
  ulBorderBottomRightRadius: "i22",
  ulBorderBottomLeftRadius: "i23",
  ulBoxShadowColor: "i24",
  ulBoxShadowH: "i25",
  ulBoxShadowV: "i26",
  ulBoxShadowBlur: "i27",
  ulBoxShadowSpread: "i28",
  ulPaddingTypeFlag: "i29",
  ulPadding: "i30",
  ulPaddingTop: "i31",
  ulPaddingRight: "i32",
  ulPaddingLeft: "i33",
  ulPaddingBottom: "i34",
  ulOpacity: "i35",
  ulRotate: "i36",
  heightAuto: "i37",
  navHeight: "i38",
  liIsSameSizeHeight: "i39",
  ulWidthAuto: "i40",
  ulHeightAuto: "i41",
  ulWidth: "i42",
  ulHeight: "i43",
  navMargin: "i44",
  showBorder: "i45",
  emptyFontFamily: "i46",
  emptyFontSize: "i47",
  emptyFontWeight: "i48",
  emptyFontColor: "i49",
  isEmptyData: "i50",
  emptyDataShowLocal: "i51",
  rankName: "i52",
  showIcon: "i53",
  iconMarginBottom: "i54",
  iconSize: "i55",
  hoverBorderRadius: "i56",
  suffixFontSize: "i57",
  suffixFontMarginBottom: "i58",
  suffixFontMarginLeft: "i59",
  prefixFontSize: "i60",
  primaryBtnFontSize: "i61",
  primaryBtnBorderWidth: "i62",
  cancleBtnFontSize: "i63",
  cancleBtnBorderWidth: "i64",
  rangeInpFontSize: "i65",
  prefixFontMarginBottom: "i66",
  prefixFontMarginRight: "i67",
  numberWidth: "i68",
  tabMaxWidth: "i69",
  tabMinWidth: "i70",
  tabMaxHeight: "i71",
  tabMinHeight: "i72",
  activeTopNavBorderTopLeftRadius: "i73",
  activeTopNavBorderTopRightRadius: "i74",
  activeTopNavBorderBottomRightRadius: "i75",
  activeTopNavBorderBottomLeftRadius: "i76",
  activeTopNavBorderWidth: "i77",
  activeTopNavBoxShadowH: "i78",
  activeTopNavBoxShadowV: "i79",
  activeTopNavBoxShadowBlur: "i80",
  activeTopNavBoxShadowSpread: "i81",
  liActiveBorderTopLeftRadius: "i82",
  liActiveBorderTopRightRadius: "i83",
  liActiveBorderBottomRightRadius: "i84",
  liActiveBorderBottomLeftRadius: "i85",
  liActiveBoxShadowH: "i86",
  liActiveBoxShadowV: "i87",
  liActiveBoxShadowBlur: "i88",
  liActiveBoxShadowSpread: "i89",
  liShowMaxWidth: "i90",
  liShowMinWidth: "i91",
  liMaxWidthVal: "i92",
  liMinWidthVal: "i93",
  ulAlignmentType: "i94",
  ulMarginTop: "i95",
  divideWidth: "i96",
  divideHeight: "i97",
  showDayBorder: "i98",
  dayBorderColor: "i99",
  dayBorderIsThemeColor: "j10",
  dayBgColor: "j11",
  dayBgColorIsThemeColor: "j12",
  dayBorderTypeFlag: "j13",
  dayBorderRadius: "j14",
  dayBorderTopLeftRadius: "j15",
  dayBorderTopRightRadius: "j16",
  dayBorderBottomRightRadius: "j17",
  dayBorderBottomLeftRadius: "j18",
  todayLunarType: "j19",
  selfLunarTxt: "j20",
  todayLunarStyleColor: "j21",
  todayLunarStyleFontFamily: "j22",
  todayLunarStyleFontSize: "j23",
  todayLunarStyleFontWeight: "j24",
  activityLeft: "j25",
  activityRight: "j26",
  activityTop: "j27",
  activityBottom: "j28",
  activityLocation3: "j29",
  emptyContent: "j30",
  emptyImgSrc: "j31",
  emptyImgClipSize: "j32",
  emptyImgRepeatType: "j33",
  emptyImgAlignType: "j34",
  emptyImgWidth: "j35",
  emptyImgHeight: "j36",
  hoverIconMargin: "j37",
  hoverIconWidth: "j38",
}

// 只在处理整个页面webjson有用；字典不需要转换了，但是有些特殊属性，后端改动很大，任然保留
const data_dictionary_map_new = {
  appId: "i0"
}

const dict_map = {}
Object.entries(data_dictionary_map).forEach(([key, value]) => {
  dict_map[value] = key
})

function checkMap() {
  const m = {}
  for (let k in data_dictionary_map) {
    if (m[k] === undefined) {
      m[k] = 1
    } else {
      alert(`警告！webjson出现重复键名${k}，请立即修改 否则会有无法预估的错误！！`)
      break
    }
  }
  console.log("ok1")
  const m2 = {}
  const vals = Object.values(data_dictionary_map)
  for (let i = 0; i < vals.length; i++) {
    const val = vals[i]
    if (m2[val] === undefined) {
      m2[val] = 1
    } else {
      alert(`警告！webjson出现重复加密键名${val}，请立即修改 否则会有无法预估的错误！！`)
      break
    }
  }
  console.log("ok2")
}

if (process.env.NODE_ENV === "development") {
  checkMap()
}

export { data_dictionary_map, data_dictionary_map_new, dict_map }
